import axios from 'axios'

export default class TipoCooperativa {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/unimed`
    this.tokenBearer = tokenBearer
  }

  getAll () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/listarUnimeds`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getConfederacaoAndFederacao () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}/listarFederacaoAndConfederacao`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
